/**
 * 
 * This File Serves All The Non-Deleted Tags Available In The Database
 * Usecase - Problemset Tags Feature
 */

import Service from "../../Service/http";

const service = new Service();

const fetchAllTags = async () => {

    const response = await service.get('api/tags/');
    return response.data.filter((tag) => {
        return !tag.isDeleted;
    });

}

export const tagOptions = fetchAllTags;